<div class="modal-header">
    <span class="modal-header-title">{{ 'CATEGORIE.CREATE_CATEGORIE' | translate }}</span>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>

<div class="modal-body">

    <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">
        <div class="row">
            <div class="col-12">
                <ff-input-lang
                    label="{{ 'FILES.NAME_CATEGORIE' | translate }}"
                    fieldId="name"
                    fieldName="name"
                    fieldType="text"
                    [clearField]="ffInputLangParams.name.clearField"
                    [required]="ffInputLangParams.name.required"
                    [inputValue]="categoryName" 
                    (changeValue)="eventFnFF('name', $event.name)">
                </ff-input-lang>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer btn-box">

    <button type="button" class="btn btn-primary btn-sm" (click)="onSend()" [disabled]="form.invalid">
        {{ 'SAVE'| translate}}
    </button>
    <button type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">
        {{ 'CLOSE' | translate}}
    </button>

</div>